import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import VueClipboard from 'vue-clipboard2'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import VueCookies from 'vue-cookies';
Vue.use(VueClipboard);
Vue.use(VueFilterDateFormat);
Vue.use(VueCookies);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
